import { defineStore } from 'pinia'
import { useFeedStore } from '~/storeModules/useFeed.js';

export const useFeedsStore = defineStore({
    id: 'feeds',

    state () {
        return {
            rooms: [],
            feeds: []
        }
    },


    actions: {
        addRoom (roomName) {
            this.rooms.push(roomName);
        },

        addFeed (roomName) {
            if (!this.feeds.includes(roomName)) this.feeds.push(roomName);
        },

        updatePosts ({ids, update}) {
            ids.forEach(id => {
                this.feeds.forEach(feed => {
                    const feedStore = useFeedStore(feed);
                    feedStore.updatePost({id, update});
                });
            })
        },

        newPost ({roomNames, post}) {
            // Check if user accepts post language
            let locales = this.$nuxt.$cookieStore.contentLocale.split('.');
            if (post.locale && !locales.includes(post.locale)) {
                return;
            }

            this.feeds.forEach(feed => {
                const feedStore = useFeedStore(feed);
                feedStore.newPost({roomNames, post});
            });
        },

        getNew () {
            this.feeds.forEach(feed => {
                const feedStore = useFeedStore(feed);
                feedStore.getNew();
            });
        },

        clear () {
            this.feeds.forEach(feed => {
                const feedStore = useFeedStore(feed);
                feedStore.clear();
            });
        }
    }
})
